import 'reflect-metadata';
import { action, observable } from 'mobx';
import { singleton } from 'tsyringe';

export enum ToastStatus {
  success = 1,
  fail = 0,
}

export type ToastMessage = {
  id: number;
  label: string;
  status: ToastStatus;
};

@singleton()
export class ToastStore {
  @observable list: ToastMessage[] = [];

  @action
  addToast(label: string, status: ToastStatus) {
    this.list.push({ id: Math.random(), label, status });
  }

  @action
  clearToast(id?: number, label?: string) {
    if (id) {
      this.list = this.list.filter((toast) => toast.id !== id);
    }
    if (label) {
      this.list = this.list.filter((toast) => toast.label !== label);
    }
  }

  @action
  clearAll() {
    this.list = [];
  }
}
